if ('querySelectorAll' in document) {
  /* First, remove data-scroll attribute from links without local anchors. */
  document.querySelectorAll('[data-scroll]').forEach((a) => {
    const id = a.hash.slice(1);

    const element = document.getElementById(id);

    if (!element) {
      delete (a.dataset.scroll);
    } else {
      a.addEventListener('click', (event) => {
        event.preventDefault();
        element.scrollIntoView({
          behavior: 'smooth',
        });
      });
    }
  });
}
